import React from 'react';
import styled from 'styled-components';
import { SESSION_EXPIRED_UI_MESSAGE } from '../../utils/sessionExpired';

type SessionExpiredModalProps = {
  open: boolean;
};

const SessionExpiredModal = ({ open }: SessionExpiredModalProps) => {
  if (!open) {
    return null;
  }

  return (
    <Overlay>
      <Panel onClick={(e) => e.stopPropagation()}>
        <Message>{SESSION_EXPIRED_UI_MESSAGE}</Message>
        <RefreshButton type="button" onClick={() => window.location.reload()}>
          새로고침
        </RefreshButton>
      </Panel>
    </Overlay>
  );
};

export default SessionExpiredModal;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  padding: 1.2rem;
  box-sizing: border-box;
`;

const Panel = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
`;

const Message = styled.p`
  margin: 0 0 2rem;
  font-size: 1.6rem;
  line-height: 1.6;
  color: #333;
  word-break: keep-all;
`;

const RefreshButton = styled.button`
  width: 100%;
  padding: 1rem 1.5rem;
  font-size: 1.6rem;
  font-weight: 600;
  color: #fff;
  background: #22468a;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #1a3668;
  }
`;
